module.exports = __webpack_public_path__ + "static/media/aftereffects.e1f07de0.png";